import React from 'react'

const LugaresdeAyuda = () => {
    return (
        <div className='container fondotransparente p-5'>

            <center><h1 classname="p-5 botonbordeazul text-white px-5 mx-5 py-3 ">Lugares de Ayuda</h1></center>

            <h4>USM SAN PEDRO</h4>

            <p>Av. 9 de Julio 1338, San Pedro de Jujuy, Jujuy</p>

            <p><a href="https://goo.gl/maps/SL6VKZtjFvYcf4gy5" target='_blank'>Ubicación</a></p>

            <h4>USM – LIBERTADOR GRAL SAN MARTIN</h4>

            <p>Jujuy 192, (esquina tucuman) Y4512 Libertador Gral San Martín, Jujuy</p>

            <p><a href="https://goo.gl/maps/KttRJA4TnViZRYx38" target='_blank'>Ubicación</a></p>

            <h4>USM – ALTO COMEDERO-</h4>

            <p>Tte. Nivoli, Tte. 1 Bolsan &amp;, San Salvador de Jujuy, Jujuy</p>

            <p><a href="https://goo.gl/maps/b2EQgs8jkFkbRjeT8" target='_blank'>Ubicación</a></p>

            <h4>USM PERICO</h4>

            <p>25 de Mayo, Perico, Jujuy</p>

            <p><a href="https://goo.gl/maps/z6iqWabny7XpKuQe7" target='_blank' >Ubicación</a></p>

            <h4>USM TILCARA</h4>

            <p>205 Bolívar, Tilcara, Jujuy, (san martin y bolívar) Y4624 Tilcara, Jujuy</p>

            <p><a href="https://goo.gl/maps/9xCkKHziSQ3Szyce9" target='_blank'>Ubicación</a></p>

            <h4>USM LA QUIACA</h4>

            <p>RP5, La Quiaca, Jujuy</p>

            <p><a href="https://goo.gl/maps/KaFBb3Q5MK9Vv8qb7" target='_blank'>Ubicación</a></p>

            <h4>USM HUMAHUACA</h4>

            <p>Av.Puerto madryn</p>

            <p>0388 456-5961</p>

            <p><a href="https://maps.app.goo.gl/QyqZ2eicbhxECaXY9" target='_blank' >Ubicación</a></p>

            <h4>USM FORESTAL/ PALPALÁ</h4>

            <p>La Menta, (yerba buena s/n)Centro Forestal, Jujuy</p>

            <p><a href="https://goo.gl/maps/tS2SFbBLsJNnLwUn8" target='_blank'>Ubicación</a></p>

            <h4>EL UMBRAL</h4>

            <p>BELGRANO 1205 ( esquina Ramirez de Velazco)</p>

            <h4>HOSPITAL NESTOR SEQUEIRO</h4>

            <p><a></a>ECUADOR 53. Bº mariano moreno</p>

            <p><a href="https://goo.gl/maps/V4H5wJ2shNUZDGzg6" target='_blank'>Ubicación</a></p>

{/*             <h4>CENTRO DE REHABILITACIÓN VICENTE ARROYABE</h4>

            <p>El Carmen jujuy</p>

            <p><a href="https://goo.gl/maps/EGf728Qpw91ZnnjK8" target='_blank' >Ubicación</a></p> */}

        </div>
    )
}

export default LugaresdeAyuda